import React, { Component } from 'react'
import SalesforceCampaignSelect from './SalesforceCampaignSelect'
import { api } from 'app/modules/sfdc/api'

class SalesforceCampaignMapping extends Component {
  constructor(props) {
    super(props)
    this.state = {
      onlyAssociateNetNew: false
    }
  }

  componentDidMount() {
    this.checkForNetNew()
  }

  checkForNetNew = async () => {
    try {
      const isNetNewPresent = await api.fetchSalesforceLeadPushCampaign()
      this.setState({ onlyAssociateNetNew: !!isNetNewPresent.campaignId })
    }
    catch (e) {
      console.log(e)
    }

  }

  handleNetNewCheckboxChange = (campaignId, change) => {
    const nextState = change
    const setCampaign = nextState ? api.replaceSalesforceLeadPushCampaign : api.setSalesforceInfluenceCampaignId
    const clearPrevCampaign = nextState ? api.setSalesforceInfluenceCampaignId : api.replaceSalesforceLeadPushCampaign
    this.setCampaign(setCampaign, campaignId)
    this.clearPrevCampaign(clearPrevCampaign)

    this.setState({
      onlyAssociateNetNew: change
    })
  }

  setCampaign = async (setCampaignFn, campaignId) => {
    try {
      await setCampaignFn(campaignId)
    }
    catch (e) {
      console.log(e)
    }
  }

  clearPrevCampaign = async (clearPrevCampaignFn) => {
    try {
      await clearPrevCampaignFn({ campaignId: null })
    }
    catch (e) {
      console.log(e)
    }
  }

  render() {
    const { type } = this.props
    const { onlyAssociateNetNew } = this.state

    const fetchCampaignFn = onlyAssociateNetNew
      ? api.fetchSalesforceLeadPushCampaign
      : api.getSalesforceInfluenceCampaignId

    const setCampaignFn = onlyAssociateNetNew
      ? api.replaceSalesforceLeadPushCampaign
      : api.setSalesforceInfluenceCampaignId

    return (
      <div>
        <span className="salesforce-campaign-mapping-select-group-title">
          Associate {type} with a Salesforce Campaign
        </span>
        <SalesforceCampaignSelect
          description={''}
          defaultSelectLabelText="Select or search for a Salesforce Campaign..."
          fetchSelectedCampaign={fetchCampaignFn}
          setSelectedCampaign={setCampaignFn}
          onToggleChange={this.handleNetNewCheckboxChange}
          toggleStatus={onlyAssociateNetNew}
          type={type}
        />

      </div>
    )
  }
}

export default SalesforceCampaignMapping



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceConfig/SalesforceCampaignMapping.js